'use es6';

import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
export const usageTracker = createTracker({
  events,
  properties: {
    namespace: 'ads'
  },
  lastKnownEventProperties: ['screen']
});
export const externalLinkTracker = usageTracker.clone({
  isBeforeUnload: true
});
export const trackEvent = (event, data) => {
  usageTracker.track(event, data);
};